// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__11SXC","title":"Info_title__3kSgs","selects":"Info_selects__2Z_UU","requiredAsterisk":"Info_requiredAsterisk__1ACje"};